<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>员工管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title" style="float: right">所属角色:</div>
            <div class="flex1" style="float: right">
              <el-select
                v-model="queryInfo.roleId"
                placeholder="请选择"
                size="small"
                clearable>
                <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">员工ID:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.userName"
                size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="14" class="display-row">
            <div
              style="
                text-align: right;
                width: 100%;
                padding-right: 10px;
                float: right;">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
              <el-button class="search-btn btn-green" @click="insert">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        :data="messageList"
        border
        height="550">
          <el-table-column type="index" align="center" label="序号" width="40">
          </el-table-column>
          <el-table-column prop="userName" label="员工ID">
          </el-table-column>
          <el-table-column prop="realName" label="员工姓名">
          </el-table-column>
          <el-table-column prop="roleName" align="center" label="所属角色">
          </el-table-column>
          <el-table-column prop="userStatus" align="center" label="员工状态" :index="indexMethod"  sortable :formatter="statusFormatter">
          </el-table-column>
          <el-table-column prop="mobileNumber" align="center" label="手机号码" >
          </el-table-column>
          <el-table-column prop="createDate" align="center" sortable label="创建时间" >
            <template v-slot="scope">
              {{ scope.row.createDate | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                  class="list-btn btn-deepblue"
                  @click="edit(scope.row)"
                >
                  编辑
                </el-button>
              </div>
              <div class="btn-row">
                <el-button
                  class="list-btn btn-warn"
                  @click="stop(scope.row)"
                >
                  {{ scope.row.userStatus == 0 ? "禁用" : "启用" }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 编辑/新增 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="editDialogVisible"
      width="30%"
      @close="dialogClose"
    >
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="dialogForm"
        label-width="100px"
        class="demo-userInfo"
      >
        <el-form-item label="员工ID：" prop="userName">
          <el-input
            v-model="userInfo.userName"
            :disabled="dialogType == 0"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工姓名：" prop="realName">
          <el-input v-model="userInfo.realName" ></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="mobileNumber">
          <el-input
            v-model="userInfo.mobileNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="重置密码：" v-if="dialogType == 0">
          <el-switch
            v-model="userInfo.resetPassword"
            active-color="#13ce66"
            inactive-color="#909399"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="登录密码：" prop="password"
        v-if="dialogType==1||userInfo.resetPassword">
          <el-input
            v-model="userInfo.password"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择角色：" prop="roleId">
          <div >
            <el-select
            :disabled="!isManage"
            v-model="userInfo.roleId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in roleList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
          </div>
        </el-form-item>
        <el-form-item label="员工状态：" prop="userStatus">
          <el-switch
            inactive-value="1"
            active-value="0"
            v-model="userInfo.userStatus"
            active-color="#13ce66"
            inactive-color="#909399"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="clearForm()">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="editSave()">提 交</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  // name: 'system/UserList',
  name: 'adminuser',
  components: { tableCon },
  data() {
    return {
      dialogType: 0, //0修改1新增
      dialogTitle: "",
      userInfo: {
        userId: "",
        userName: "",
        realName: "",
        mobileNumber: "",
        password: "",
        roleId: "",
        userStatus: "",
        resetPassword:false //0不重置 1重置
      },
      rules: {
        userName: [
          { required: true, message: "请输入员工ID", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 0){
                callback();
              }
              var reg = /^[a-z0-9]{6,16}$/; //6-16位英文或数字
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("输入6-16位英文或数字"));
              }
            },
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var reg = /^[\u4e00-\u9fa5]{2,8}$/; //2-8位中文汉字
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("输入2-8位中文汉字"));
              }
            },trigger: "blur"
          },
        ],
        mobileNumber: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const regMobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
              if (regMobile.test(value)) {
                callback();
              }
              callback(new Error("请输入合法的手机号"));
            },trigger: "blur"
          },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              console.log(rule);
              var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,16}$/; //6-16位数字大小写字母组合
              if (reg.test(value)) {
                callback();
              } else {
                callback(
                  new Error("请输入6-16位数字大小写字母组合，至少包含其中两种")
                );
              }
            },trigger: "blur"
          },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
      queryInfo: {
        userName: "",
        roleName: "",
        pageSize: 10,
        pageNum: 1,
      },
      editDialogVisible: false,
      roleList: [],
      total: 0,
      messageList: [],
    };
  },
  computed:{
    isManage(){
      return window.sessionStorage.getItem('role') == '超超级管理员'
    }
  },
  methods: {
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getRoleList();
      this.getMessageList();
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getRoleList();
      this.getMessageList();
    },
    editSave() {
      this.queryInfo.pageNum = 1;
      var my = this;
      //保存按钮
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          if(my.dialogType==0&&!my.userInfo.resetPassword){
            my.userInfo.password=="";
          }
          var url = "emp/empSystemManage/insertAndEdit";
          const { data: res } = await my.$http.post(url, my.userInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getMessageList();
            my.editDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    clearForm() {
      this.initForm();
      this.editDialogVisible = false;
    },
    initForm() {
      this.userInfo.roleId = "";
      this.userInfo.userId = "";
      this.userInfo.userName = "";
      this.userInfo.realName = "";
      this.userInfo.mobileNumber = "";
      this.userInfo.password = "";
      this.userStatus = "0";
    },
    searchList() {
      //查询
      console.log(this.queryInfo);
      this.queryInfo.pageNum = 1;
      this.getRoleList();
      this.getMessageList();
    },
    async getMessageList() {
      //获取信息列表
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get("emp/empSystemManage/list", {
        params: this.queryInfo,
      });
      console.log(res);
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    async getRoleList() {
      //获取角色列表
      const { data: res } = await this.$http.get("role/roleList");
      console.log(res);
      this.roleList = res.data;
    },
    queryInfoClear() {
      //清空
      this.queryInfo = {
        userName: "",
        roleId: "",
        pageSize: 10,
        pageNum: 1,
      };
    },
    statusFormatter(row, column) {
      if (row.userStatus == 0) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    edit(row) {
      this.initForm();
      this.dialogType = 0;
      this.dialogTitle = "编辑";
      //编辑
      this.userInfo = {
        userId: row.userId,
        userName: row.userName,
        realName: row.realName,
        mobileNumber: row.mobileNumber,
        password: "",
        roleId: row.roleId,
        userStatus: row.userStatus,
      };
      let _this = this;
      this.$nextTick(function () {
         _this.$refs.dialogForm.clearValidate();
      });
      this.editDialogVisible = true;
    },
    insert() {
      this.userInfo.userStatus='0'
      this.editDialogVisible = true;
      this.initForm();
      this.dialogType = 1;
      this.dialogTitle = "新增员工";
      let _this = this;
      this.$nextTick(function () {
         _this.$refs.dialogForm.clearValidate();
      });
    },
    dialogClose() {
      // this.initForm();
    },
    async stop(row) {
      var strStatus = "";
      if (row.userStatus == "0") {
        strStatus = "禁用"
      } else {
        strStatus = "启用"
      }
      this.$confirm(`确定要${strStatus}该员工吗？`,  {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        var url = "emp/empSystemManage/update/status";
        const { data: res } = await this.$http.post(url, {
          userId: row.userId,
          userStatus: row.userStatus,
        });
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.message,
          });
        }
        this.getMessageList();
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消改操作"
        });
      });
      /*var url = "emp/empSystemManage/update/status";
      const { data: res } = await this.$http.post(url, {
        userId: row.userId,
        userStatus: row.userStatus,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        });
      }
      this.getMessageList();*/
    },
  },
  created() {
    this.getMessageList();
    this.getRoleList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
